export default {
  tutor: {
    TutorName: 'Tutor Name',
    TutorMobile: 'Tutor Mobile',
    TutorWeChat: 'Tutor WeChat',
    UserStatus: 'User Status',
    OnlineStatus: 'Online Status',
    OnLine: 'OnLine',
    OffLine: 'OffLine',
    ChooseTutor: 'Choose Tutor'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/myg/tutor.js